import styled from 'styled-components';

export const BoldText = styled.div`
  > b {
    font-weight: 600;
  }
`;
